$(document).ready(function () {
    const $form = $('#search-form');
    $form.on('submit', function (e) {
        e.preventDefault();
        const formData = $form.serializeArray();
        const values = { name: '', group: '', energy: '' };
        formData.forEach(item => {
            values[item.name] = item.value || '';
        });
        window.dispatchEvent(new CustomEvent('searchFormSubmit', { detail: values }));
    });

    $('.btn-danger').on('click', function () {
        $form.find('input[name="name"]').val('');

        const $categorySelect = $form.find('select[name="category"]');
        $categorySelect.val('');

        const $energySelect = $form.find('select[name="energy"]');
        $energySelect.val('0');

        if ($categorySelect.hasClass('select2')) {
            $categorySelect.trigger('change.select2');
        }
        if ($energySelect.hasClass('select2')) {
            $energySelect.trigger('change.select2');
        }

        window.dispatchEvent(new CustomEvent('searchFormReset'));
    });
});
